export default __webpack_public_path__ + "static/media/side_line.7b07b738.svg";